import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import { Input } from 'reactstrap';
import { productProductGroupFocusFilter } from '../../../actions';

const ProductGroupFocusFilter = () => {
  const dispatch = useDispatch();
  const { productProductGroupFocus } = useSelector(({ product }) => product);

  const [focus, setFocus] = useState(productProductGroupFocus);

  const handleChange = (event) => {
    const { checked } = event.target;
    setFocus(checked);
    dispatch(productProductGroupFocusFilter(checked)); // Dispatch the action with the updated checkbox value
  };

  // if(focus){
  //   console.log('focusGroup: ', focus);
  //   console.log('productProductGroupFocus: ', productProductGroupFocus);
  // }

  return (
    <>
      <Checkbox
        style={{ padding: '5px' }}
        color="primary"
        checked={focus}
        onChange={handleChange}
      />
      {/* <Input
        type="text"
        name="focusText"
        id="focusText"
        value={focus ? 'Y' : ''}
        onChange={() => {}}
      /> */}
    </>
  );
};

export default ProductGroupFocusFilter;

// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Checkbox from '@material-ui/core/Checkbox';
// import { Label, Input } from 'reactstrap';
// import { productProductGroupFocusFilter } from '../../../actions';

// const ProductGroupFocusFilter = () => {
//     const dispatch = useDispatch()
//     const { productProductGroupFocus } = useSelector(({product}) => product)

//     const [focus, setFocus] = useState(productProductGroupFocus);

//     const handleChange = () => {
//         setFocus(!focus);
//         // dispatch(productProductGroupFocusFilter(focus));
//     }
    
//     console.log('focus: ', focus);
//     console.log('productProductGroupFocus: ', productProductGroupFocus);

//     return (
//         <>
//         <Checkbox
//             style={ {padding: '5px'}}
//             color="primary"
//             // value={focus}
//             checked={focus}
//             onChange={handleChange}
//         />
//         <Input
//             type="text"
//             name="focusText"
//             id="focusText"
//             value={focus ? "Y" : ""}
//             onChange={() => {}} 
//         /> 
//         </>
//     )
// }

// export default ProductGroupFocusFilter;